/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type ListingSellerContactResponseDtoRole = typeof ListingSellerContactResponseDtoRole[keyof typeof ListingSellerContactResponseDtoRole] | null;


export const ListingSellerContactResponseDtoRole = {
  PRIVATE_ADVERTISER: 'PRIVATE_ADVERTISER',
  BROKER: 'BROKER',
  REAL_ESTATE_AGENCY: 'REAL_ESTATE_AGENCY',
  DEVELOPER: 'DEVELOPER',
} as const;
